import React, { useMemo } from 'react';
import { gql } from 'urql';
import { useAuthenticatedQuery } from 'client/hooks';

import {
    FollowingCollegesForPlayersQuery,
    FollowingCollegesForPlayersQueryVariables,
    FollowingCollegesForPlayersDocument,
} from '../../../generated/spin-graphql';
import { useAppState } from 'client/providers/AppProvider';
import { PlayerFollowing } from './PlayerFollowing';
import { CONVERT_TO_MILES } from 'shared/shared.constants';

gql`
    query FollowingCollegesForPlayers($closeSearch: espin_college_bool_exp!, $farSearch: espin_college_bool_exp!) {
        all_follows: espin_follow(where: { follow_type: { _eq: player_follows_college } }) {
            ...PlayerFollowing
        }
        close_colleges: espin_follow(where: { college: $closeSearch, follow_type: { _eq: player_follows_college } }) {
            ...PlayerFollowing
        }
        far_colleges: espin_follow(where: { college: $farSearch, follow_type: { _eq: player_follows_college } }) {
            ...PlayerFollowing
        }
    }
`;

type Props = {};

export const PlayerFollowingContainer: React.FC<Props> = ({}) => {
    const { user } = useAppState();
    const { isReady, data } = useAuthenticatedQuery<
        FollowingCollegesForPlayersQuery,
        FollowingCollegesForPlayersQueryVariables
    >(
        {
            query: FollowingCollegesForPlayersDocument,
            variables: {
                closeSearch: {
                    address: {
                        location: {
                            _st_d_within: {
                                distance: 100 * CONVERT_TO_MILES,
                                from: {
                                    type: 'Point',
                                    coordinates: user?.player_profile?.address.location?.['coordinates'] ?? [0, 0],
                                },
                            },
                        },
                    },
                },
                farSearch: {
                    _not: {
                        address: {
                            location: {
                                _st_d_within: {
                                    distance: 100 * CONVERT_TO_MILES,
                                    from: {
                                        type: 'Point',
                                        coordinates: user?.player_profile?.address.location?.['coordinates'] ?? [0, 0],
                                    },
                                },
                            },
                        },
                    },
                },
            },
            pause: !user,
        },
        ['espin_follow'],
    );

    const { far_colleges, all_follows, close_colleges } = data ?? {};
    const listOfFollows = useMemo(() => all_follows?.map((f) => f.college?.id), [all_follows]);
    return (
        <>
            {isReady && (
                <PlayerFollowing
                    closeColleges={close_colleges}
                    farColleges={far_colleges}
                    listOfFollows={listOfFollows}
                />
            )}
        </>
    );
};
